<script setup lang="ts">
import { computed, ref } from 'vue';

const comm = useCommStore();
const stopping = ref(false);

// `impersonated_by` 是后端在被模拟用户的 userinfo 里注入的 admin 身份;
// `comm.userInfo` 自身则是「被模拟的目标用户」的资料。
const impersonator = computed(() => comm.userInfo?.impersonated_by);
const targetLabel = computed(
  () => comm.userInfo?.email || comm.userInfo?.nickname || comm.userInfo?.uid || 'unknown',
);

async function stop() {
  if (stopping.value) return;
  stopping.value = true;
  try {
    await $fetch('/api/auth/unimpersonate', { method: 'POST' });
    // Session 已切回 admin,回到管理后台,重新拉取 userInfo
    window.location.href = '/admin/users';
  } catch (err: any) {
    stopping.value = false;
    alert(err?.data?.message || err?.message || 'Stop impersonating failed');
  }
}
</script>

<template>
  <div v-if="impersonator" class="impersonation-banner">
    <div class="inner">
      <span class="dot" />
      <span class="msg">
        You are impersonating <strong>{{ targetLabel }}</strong>
        <span class="sub">· admin {{ impersonator.email || impersonator.name || impersonator.id }}</span>
      </span>
      <button class="stop" :disabled="stopping" @click="stop">
        <span v-if="stopping">Returning…</span>
        <span v-else>Stop impersonating</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.impersonation-banner {
  position: sticky;
  top: 0;
  z-index: 10001;
  width: 100%;
  background: linear-gradient(90deg, #b45309 0%, #d97706 100%);
  color: #fffbeb;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
}
.inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #fef3c7;
  box-shadow: 0 0 0 4px rgba(254, 243, 199, 0.25);
}
.msg { flex: 1; }
.msg strong { font-weight: 700; }
.sub { opacity: 0.75; font-weight: 400; margin-left: 8px; }
.stop {
  border-radius: 9999px;
  background: rgba(0, 0, 0, 0.35);
  color: #fffbeb;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.25);
  cursor: pointer;
  transition: background 0.15s;
}
.stop:hover { background: rgba(0, 0, 0, 0.55); }
.stop:disabled { opacity: 0.6; cursor: wait; }
</style>
